import { useLayoutEffect, useState } from 'react';
import { Key } from 'antd/es/table/interface';

export const useUsersStyle = (expandedRowKeys: readonly Key[]) => {
  const [dateEl, setDateEl] = useState<NodeListOf<Element> | null>(null);

  useLayoutEffect(() => {
    const tryAcquire = () => {
      const usersDate = document.querySelectorAll('[data-group="usersDate"]');

      if (usersDate) setDateEl(usersDate);
    };

    tryAcquire();

    const observer = new MutationObserver(() => {
      tryAcquire();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useLayoutEffect(() => {
    function isExpandedIndex(
      i: number,
      expandedRowKeys: readonly Key[],
    ): boolean {
      const keyStr = String(i);
      return expandedRowKeys.some((k) => String(k) === keyStr);
    }
    const adjust = (els: NodeListOf<Element> | null) => {
      if (!els || els.length === 0) return;
      for (let i = 0; i < els.length; i++) {
        const plusCell = els[i]?.parentNode?.parentNode
          ?.children[0] as HTMLElement | null;
        const statusCell = els[i]?.parentNode?.parentNode
          ?.children[5] as HTMLElement | null;
        const row = els[i]?.parentNode?.parentNode as HTMLElement | null;
        if (plusCell instanceof HTMLElement) {
          plusCell.style.borderLeft = '4px solid rgba(217, 217, 217, 0.27)';
          plusCell.style.width = '88px';
        }
        if (statusCell instanceof HTMLElement) {
          statusCell.style.borderRight = '4px solid rgba(217, 217, 217, 0.27)';
        }
        if (row instanceof HTMLElement) {
          if (isExpandedIndex(i, expandedRowKeys)) {
            row.style.backgroundColor = 'rgba(183, 195, 223, 0.15)';
          } else {
            row.style.backgroundColor = '#fff';
          }
        }
      }
    };
    adjust(dateEl);
  }, [dateEl, expandedRowKeys]);
};
